import React, { useEffect, useState } from "react";
import SplashPage from './SplashPage';
import { Badge, Button, Col, Container, Row, Spinner } from "react-bootstrap";
import { BsTicketDetailed } from 'react-icons/bs';
import MessageContainer from "../components/support/MessageContainer";
import CommnetBox from "../components/support/CommentBox";
import PrivateApi from "../services/PrivateApiService";
import TicketDateComponent from "../components/support/TicketDateComponent";
import { useParams } from "react-router-dom";
import TickList from "../components/support/TickList";
import { FaCheck } from "react-icons/fa";
import { useAuthState } from "../context/AuthContext";
import { useQuery, useQueryClient } from "react-query";
import TicketUserFilter from "../components/support/TicketUserFilter";
import EnergoTooltip from "../components/shared/Tooltip";



/**
 * SupportPage
 * 
 * @returns gui
 */
const SupportPage = () => {

    const { ticket_id } = useParams() || undefined; // url parameter
    const { user, tooltips, tooltipsTrigger } = useAuthState(); // logged User
    const API = new PrivateApi(); // API
    const queryClient = useQueryClient();
    const [isClosing, setIsClosing] = useState(false); // loading for ticket closing
    const [openTicket, setOpenTickets] = useState([]); // open Tickets
    const [filteredOpenTickets, setFilteredOpenTickets] = useState([]);
    const [closedTickets, setClosedTickets] = useState([]); // closed Tickets
    const [filteredClosedTickets, setFilteredClosedTickets] = useState([]);
    const [anlagen, setAnlagen] = useState([]) // anlagen of tickets
    const [selectedTicket, setSelectedTicket] = useState(); // selected ticket
    const [dateDisplay, setDateDisplay] = useState(""); // string date which is displayed on the right side
    const [dateIsEnergo, setDateIsEnergo] = useState(false); // bool for applying color scheme to date element
    const [messages, setMessages] = useState([]); // bool when new message has been posten

    // fetch data
    const { data, error, isLoading } = useQuery("GET_TICKETS_QUERY", API.get_Ticket, { staleTime: 30000 });

    // * effect to geather Tickets
    useEffect(() => {
        document.addEventListener("keydown", searchKeyCombo); // add listener to search field

        if (data !== undefined && data !== null) {
            setOpenTickets(data.open);
            setFilteredOpenTickets(data.open);
            setFilteredClosedTickets(data.closed);
            setClosedTickets(data.closed);
            setAnlagen(data.anlagen);
        }
    }, [data]);



    // Handler to close Ticket on btn click
    const closeTicketHandler = () => {
        setIsClosing(true);
        API.get_Ticket_close(selectedTicket.id)
            .then(res => {
                let data = res.data;
                setSelectedTicket(data);
                setIsClosing(false);

                /**
                 * because ticket is returned, remove it from open tickets list
                 * and push him to closed ones
                 */
                var temp_list = openTicket.filter(ot => ot.id !== data.id);
                setOpenTickets(temp_list);
                temp_list = [...closedTickets];
                temp_list.push(data);
                setClosedTickets(temp_list);
                queryClient.invalidateQueries("GET_TICKETS_QUERY");
            })
            .catch(err => {
                setIsClosing(false);
            });
    }

    // key shortcut mac/win
    const searchKeyCombo = (e) => {
        if (e.metaKey && e.which === 75) {
            document.getElementById('search-field').click();
        }
        const { ctrlKey } = e;
        if (ctrlKey && e.which === 75) {
            e.preventDefault();
            document.getElementById('search-field').click();
        }
    }

    // if loading or error return splashpage
    if (isLoading) return <SplashPage />
    if (error) return <SplashPage error={"Fehler aufgetreten."} />

    // GUI
    return (
        <Container className="text-start">
            <Row className="align-items-center">
                <Col xs="12" md="7" xl="9">
                    <h3><span className="text-energo">ENERGO</span> Support</h3>
                    {selectedTicket !== undefined ?
                        <h5>
                            {selectedTicket.name} (#{selectedTicket.id}) &nbsp;
                            {selectedTicket.stage_id[1] === "Erledigt" ?
                                <FaCheck className="text-energo" size={30} />
                                :
                                <small className="text-secondary">
                                    <Badge bg={
                                        selectedTicket.stage_id[1] === "Warten auf Drittpartei" ? "primary" :
                                            selectedTicket.stage_id[1] === "On Hold" ? "warning" :
                                                selectedTicket.stage_id[1] === "Warten auf Kunde" ? "violet" :
                                                    selectedTicket.stage_id[1] === "Warten auf ENERGO" ? "energo" :
                                                        "secondary"} className="rounded-pill">
                                        <BsTicketDetailed /> {selectedTicket.stage_id[1]}
                                    </Badge>
                                </small>
                            }
                        </h5>
                        : null}
                </Col>
                <Col xs="12" md="5" xl="3" className="text-end">
                    <a hidden={selectedTicket === undefined} href="neu/" className="btn btn-sm btn-energo rounded-pill">Neues Ticket</a>
                </Col>
            </Row>

            <Row className="mt-5">
                {/* left column */}
                <Col xl="3" className="mb-5">
                    <div className="sticky-top" style={{top: "100px"}}>
                        <Row className="mt-3" hidden={user.x_is_house_management === false}>
                            <Col xs="12" md="6" xl="12" className="text-center">
                                <TicketUserFilter 
                                    openTickets={openTicket}
                                    closedTickets={closedTickets}
                                    setSelectedTicket={setSelectedTicket}
                                    setFilteredOpenTickets={setFilteredOpenTickets}
                                    setFilteredClosedTickets={setFilteredClosedTickets}
                                />
                            </Col>
                        </Row>
                        <Row className="mt-5">
                            <Col xs="12" md="6" xl="12" style={{display : "flex", justifyContent: "center"}}>
                                <TickList title="Offene Tickets" tickets={filteredOpenTickets} selectedTicket={selectedTicket} setSelectedTicket={setSelectedTicket} />
                                {tooltipsTrigger?
                                    tooltips.find(t => t.code === 7002) !== undefined?
                                        <EnergoTooltip text={tooltips.find(t => t.code === 7002).help_text} position="right" /> : null
                                :null}
                            </Col>
                            <Col xs="12" md="6" xl="12" style={{display : "flex", justifyContent: "center"}}>
                                <TickList title="Geschlossene Tickets" closed={ticket_id !== undefined && ticket_id !== null? false:true} tickets={filteredClosedTickets} selectedTicket={selectedTicket} setSelectedTicket={setSelectedTicket} />
                                {tooltipsTrigger?
                                    tooltips.find(t => t.code === 7003) !== undefined?
                                        <EnergoTooltip text={tooltips.find(t => t.code === 7003).help_text} position="right" /> : null
                                :null}
                            </Col>
                        </Row>
                    </div>

                </Col>

                {selectedTicket !== undefined ?
                    <>
                        {/* middle column */}
                        <Col xl="8">
                            <MessageContainer anlagen={anlagen} selectedTicket={selectedTicket} setDate={setDateDisplay} setIsEnergo={setDateIsEnergo} messages={messages} setMessages={setMessages} />
                            <CommnetBox hidden={selectedTicket.stage_id[1] === "Erledigt"} ticket={selectedTicket.id} messages={messages} setMessages={setMessages} />
                            <div className="text-center">
                                {selectedTicket !== undefined && selectedTicket.stage_id[1] !== "Erledigt" ?
                                    <div style={{display: "flex", justifyContent: "center"}}>
                                        <Button onClick={() => closeTicketHandler()} disabled={isClosing} className="btn-danger" style={{ marginRight: "10px" }}>
                                            {isClosing ?
                                                <div>
                                                    <Spinner size="sm" animation="border" /> Ticket schließen läuft...
                                                </div>
                                                : "Frage beantwortet / Ticket schließen"}
                                        </Button>
                                        {tooltipsTrigger?
                                            tooltips.find(t => t.code === 7004) !== undefined?
                                                <EnergoTooltip text={tooltips.find(t => t.code === 7004).help_text} position="right" /> : null
                                        :null}
                                    </div>
                                : null
                                }
                            </div>
                        </Col>

                        {/* right column */}
                        <Col xl="1">
                            <TicketDateComponent date={dateDisplay} isEnergo={dateIsEnergo} />
                        </Col>
                    </>
                    :
                    <Col xl="9" className="text-center">
                        <h5 className="text-muted">Es wurden keine offenen Tickets gefunden.</h5>
                        <br />
                        <a href="neu/" className="btn btn-energo rounded-pill">Jetzt neues Ticket erstellen</a>
                    </Col>
                }
            </Row>
        </Container>
    )
}

export default SupportPage;